var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21411 6.14257C6.58733 5.87635 7.03728 5.73846 7.65069 5.66705V6.16865C7.65069 6.64774 8.04626 7.03612 8.53423 7.03612C9.02219 7.03612 9.41776 6.64774 9.41776 6.16865V5.59195C9.69113 5.59033 9.98487 5.59033 10.3013 5.59033C10.6177 5.59033 10.9115 5.59033 11.1848 5.59195V6.16865C11.1848 6.64774 11.5804 7.03612 12.0684 7.03612C12.5563 7.03612 12.9519 6.64774 12.9519 6.16865V5.66705C13.5653 5.73846 14.0153 5.87635 14.3885 6.14257C14.6385 6.32093 14.8584 6.5368 15.04 6.78228C15.3724 7.23149 15.5084 7.79393 15.564 8.62648H5.03857C5.09418 7.79393 5.23014 7.23149 5.56256 6.78228C5.74421 6.5368 5.96408 6.32093 6.21411 6.14257Z",
    fill: "#6638A2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0063 9.49384C5 9.879 5 10.3099 5 10.7952C5 12.9637 5 14.0479 5.56247 14.808C5.74412 15.0535 5.96399 15.2694 6.21402 15.4477C6.98819 16 8.09253 16 10.3012 16C10.7954 16 11.2342 16 11.6265 15.9938V15.9532C11.6265 15.4605 11.6264 15.1604 11.6682 14.9015C11.8977 13.4786 13.0343 12.3627 14.4836 12.1373C14.7473 12.0963 15.0529 12.0963 15.5548 12.0964H15.5961C15.6024 11.7112 15.6024 11.2803 15.6024 10.7952C15.6024 10.3099 15.6024 9.879 15.5961 9.49384L15.5853 9.49396H5.01697L5.0063 9.49384ZM8.53414 10.9397C8.29016 10.9397 8.09237 11.1339 8.09237 11.3735C8.09237 11.613 8.29016 11.8072 8.53414 11.8072H12.0683C12.3123 11.8072 12.51 11.613 12.51 11.3735C12.51 11.1339 12.3123 10.9397 12.0683 10.9397H8.53414Z",
    fill: "#6638A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3884 15.4478C13.9308 15.7741 13.358 15.9076 12.51 15.9622C12.5101 15.4358 12.5121 15.2156 12.5408 15.0372C12.7105 13.9855 13.5506 13.1607 14.6217 12.9941C14.8034 12.9659 15.0277 12.9639 15.5639 12.9639C15.5083 13.7964 15.3723 14.3589 15.0399 14.8081C14.8583 15.0535 14.6384 15.2694 14.3884 15.4478Z",
    fill: "#6638A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97582 4.43374C8.97582 4.19419 8.77804 4 8.53406 4C8.29008 4 8.09229 4.19419 8.09229 4.43374V6.16868C8.09229 6.40822 8.29008 6.6024 8.53406 6.6024C8.77804 6.6024 8.97582 6.40822 8.97582 6.16868V4.43374Z",
    fill: "#6638A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.51 4.43374C12.51 4.19419 12.3122 4 12.0682 4C11.8242 4 11.6265 4.19419 11.6265 4.43374V6.16868C11.6265 6.40822 11.8242 6.6024 12.0682 6.6024C12.3122 6.6024 12.51 6.40822 12.51 6.16868V4.43374Z",
    fill: "#6638A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateSmall);
export default __webpack_public_path__ + "static/media/date-small.a332fbfd58c4d699f23c759f50c262db.svg";
export { ForwardRef as ReactComponent };